import React, { useEffect, useState } from 'react';
import { addSpace } from '../../Components/Tools';
import ApexCharts from 'react-apexcharts';
import axios from 'axios';
import qs from 'qs';

function BilanInteretsDette(props)
{
    const [series, setSeries] = useState(undefined)
    const [options, setOptions] = useState(undefined)

    useEffect(() => {

        var filename = "Interêts de la dette";

        axios.post('https://app-slfinance.fr/api/graph.php', qs.stringify({
        	'InteretsDette': true,
            'id_budget': props.user.id_budget,
            'nomen': props.user.nomen,
            'annees': props.annees,
            'hypothese': 'R'
        }))
        .then(async (res) => {
            var state = {
                series: [{
                    name: 'Interêts de la dette',
                    data: res.data[0],
                    color: '#2980b9',
                    type: 'column'
                }],
                options: {
                    title: {
                        text: filename
                    },
                    chart: {
                        toolbar: {
                            show: props.download?true:false,
                            export: {
                                svg: {
                                  filename: filename.replace("'", '_').replace("/", '_').replace(".", ''),
                                },
                                png: {
                                  filename: filename.replace("'", '_').replace("/", '_').replace(".", ''),
                                },
                                csv: {
                                  filename: filename.replace("'", '_').replace("/", '_').replace(".", ''),
                                },
                            },
                        },
                        type: 'bar'
                    },
                    plotOptions: {
                        bar: {
                            borderRadius: 4
                        },
                    },
                    legend: {
                        position: 'right',
                        offsetY: 40
                    },
                    xaxis: {
                        categories: props.annees
                    },
                    yaxis: {
                        labels: {
                            formatter: function (value) {
                                return addSpace(Math.round(value*100)/100, true) + " €";
                            }
                        },
                    },
                    dataLabels: {
                        formatter: (val) => {
                            return '';
                        }
                    },
                    fill: {
                        opacity: 1
                    }
                }
            }

            await setOptions(state.options)
            await setSeries(state.series)
        })
    }, [])


	return (
		<div style={{margin: 5}}>
            {options && series?
			<ApexCharts
                series={series}
                options={options}
                width={'100%'}
                height={props.height?props.height:300}
                type="bar"
            />:null}
		</div>
	)
}

export default BilanInteretsDette;
